import { useRef, useState } from "react";
import { Upload, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const FileUpload = ({ onUploaded, accept = ".pdf,.jpg,.jpeg,.png,.webp", label = "Wybierz plik", testid }) => {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [success, setSuccess] = useState("");

    const handleChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setUploading(true);
        setSuccess("");
        try {
            const fd = new FormData();
            fd.append("file", file);
            const { data } = await api.post("/upload", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setSuccess(data.original_filename || "Plik przesłany");
            onUploaded?.(data);
            toast.success("Plik został przesłany.");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Nie udało się przesłać pliku.");
        } finally {
            setUploading(false);
            if (inputRef.current) inputRef.current.value = "";
        }
    };

    return (
        <div className="flex items-center gap-3" data-testid={testid}>
            <button
                type="button"
                onClick={() => inputRef.current?.click()}
                disabled={uploading}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-dashed border-[#0D4F3C]/40 text-[#0D4F3C] text-sm hover:bg-[#0D4F3C]/5 transition-colors disabled:opacity-50"
            >
                {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
                {uploading ? "Wysyłanie..." : label}
            </button>
            {success && (
                <span className="inline-flex items-center gap-1.5 text-xs text-emerald-700">
                    <Check size={12} /> {success}
                </span>
            )}
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                onChange={handleChange}
                className="hidden"
                data-testid={testid ? `${testid}-input` : undefined}
            />
        </div>
    );
};

export default FileUpload;
